import { useOS, OS } from 'hooks';
import { ReactNode } from 'react';

import { cn } from 'styles';
import { ensureArray } from 'utils/array';
import { quickSwitch } from 'utils/conditions';

interface ShortcutProps {
  className?: string;
  content?: ReactNode;
  keys: string | string[];
  joiner?: string;
}

function fixKey(os: OS, key: string) {
  const ref = key.toLowerCase();

  const isMac = os === 'macOS';

  return quickSwitch(ref, [
    { is: 'ctrl', then: isMac ? '⌘' : 'Ctrl' },
    { is: 'alt', then: isMac ? '⌥' : 'Alt' },
    { is: 'shift', then: '⇧' },
    { is: 'enter', then: '↵' },
    { is: true, then: ref.toUpperCase() },
  ]);
}

export function ShortcutTag({ className, content, keys, joiner = '+' }: ShortcutProps) {
  const os = useOS();

  const text =
    content ??
    ensureArray(keys)
      .map((key) => fixKey(os, key))
      .join(joiner);

  return (
    <span className={cn('ml-auto text-xs tracking-widest opacity-60', className)}>{text}</span>
  );
}
